import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import R from 'ramda';
import Heading from '@cotyorg/ccx-atoms/Heading';
import Paragraph from '@cotyorg/ccx-atoms/Paragraph';
import Link from '@cotyorg/ccx-atoms/Link';
import Picture from '@cotyorg/ccx-atoms/Picture';
import Button from '@cotyorg/ccx-atoms/Button';

const MAX_LONG_DESC_LENGTH = 150;

const FilterProductBanner = ({
  product,
  shopAllVariantsText,
  truncatedLinkText,
  onShopAllVariantsClick,
}) => {
  let longDescription = R.propOr('', 'longDescription', product);
  const longDescriptionIsTruncated =
    longDescription.length > MAX_LONG_DESC_LENGTH;

  if (longDescriptionIsTruncated) {
    longDescription = longDescription.substring(0, MAX_LONG_DESC_LENGTH);
    longDescription = longDescription.substring(
      0,
      Math.min(longDescription.length, longDescription.lastIndexOf(' '))
    );
    longDescription = `${longDescription}… `;
  }

  const onClick = () => {
    if (onShopAllVariantsClick) {
      onShopAllVariantsClick({ ...product, action: shopAllVariantsText });
    }

    if (window) {
      window.location.assign(R.path(['link', 'url'], product));
    }
  };

  return (
    <div className="filter-product-banner-wrapper">
      <div className="filter-product-banner grid-x">
        <div className="cell xsmall-7 small-7 medium-5">
          <Picture
            src={R.prop('additionalImageSrc', product)}
            srcset={R.prop('additionalImageSrcSet', product)}
            extraClass="filter-product-banner__image"
          />
        </div>
        <div className="cell xsmall-9 small-9 medium-11">
          <Heading
            level={3}
            extraClass="filter-product-banner__title"
            dangerouslySetInnerHTML={{ __html: R.prop('title', product) }}
          />
          <Heading level={5} extraClass="filter-product-banner__description">
            {R.prop('description', product)}
          </Heading>
          {R.prop('longDescription', product) && (
            <Paragraph
              extraClass="filter-product-banner__long-description"
              enableBBCode={false}
            >
              {longDescriptionIsTruncated ? (
                <Fragment>
                  {longDescription}
                  <Link link={R.path(['link', 'url'], product)}>
                    {truncatedLinkText}
                  </Link>
                </Fragment>
              ) : (
                longDescription
              )}
            </Paragraph>
          )}
          <Button
            onClick={onClick}
            extraClass="button button--primary filter-product-banner__link"
          >
            {shopAllVariantsText}
          </Button>
        </div>
      </div>
    </div>
  );
};

FilterProductBanner.propTypes = {
  product: PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    longDescription: PropTypes.string,
    imageSrc: PropTypes.string.isRequired,
    link: PropTypes.shape({
      url: PropTypes.string.isRequired,
    }).isRequired,
    variants: PropTypes.array.isRequired,
  }).isRequired,
  truncatedLinkText: PropTypes.string.isRequired,
  shopAllVariantsText: PropTypes.string.isRequired,
  onShopAllVariantsClick: PropTypes.func,
};

export default FilterProductBanner;
